import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Info } from 'lucide-react';

/**
 * Reusable collapsible section with header and content
 * Used in proposals page for grouping proposals by status
 */
const CollapsibleSection = ({
  title,
  count = 0,
  defaultOpen = true,
  children,
  infoTooltip,
  headerAction,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`border border-gray-200 rounded-lg bg-white ${className}`}>
      {/* Header */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors rounded-t-lg"
        aria-expanded={isOpen}
      >
        <div className="flex items-center gap-3">
          {/* Chevron Icon */}
          <span className="text-gray-400">
            {isOpen ? (
              <ChevronDown className="w-5 h-5" />
            ) : (
              <ChevronRight className="w-5 h-5" />
            )}
          </span>

          {/* Title */}
          <h3 className="text-sm font-semibold text-gray-900">
            {title}
          </h3>

          {/* Count Badge */}
          {count > 0 && (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
              {count}
            </span>
          )}

          {/* Info Tooltip */}
          {infoTooltip && (
            <div className="relative group">
              <Info className="w-4 h-4 text-gray-400 cursor-help" />
              <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block z-10">
                <div className="bg-gray-900 text-white text-xs rounded-lg py-2 px-3 max-w-xs whitespace-normal">
                  {infoTooltip}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Header Action (e.g., toggle, edit button) */}
        {headerAction && (
          <div onClick={(e) => e.stopPropagation()}>
            {headerAction}
          </div>
        )}
      </button>

      {/* Content */}
      {isOpen && (
        <div className="px-4 pb-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
